import { Historico } from "./Historico";

export default Historico;
